
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Preview } from "@lighting-beetle/lighter-styleguide";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Lists`}</h1>
    <p>{`There styles for unordered, ordered and description lists and their inline variants.`}</p>
    <h2>{`Variants`}</h2>
    <h3>{`Unordered list`}</h3>
    <Preview mdxType="Preview">
  <ul>
    <li>Est dolor incididunt eiusmod.</li>
    <li>
      Ad dolor ea aliquip officia.
      <ul>
        <li>Est dolor incididunt eiusmod.</li>
        <li>Ad dolor ea aliquip officia.</li>
      </ul>
    </li>
    <li>Aliqua anim esse eu ex.</li>
    <li>Est sit enim est.</li>
    <li>Labore deserunt elit dolor commodo mollit.</li>
  </ul>
    </Preview>
    <h3>{`Ordered list`}</h3>
    <Preview mdxType="Preview">
  <ol>
    <li>Est dolor incididunt eiusmod.</li>
    <li>
      Ad dolor ea aliquip officia.
      <ol>
        <li>Est dolor incididunt eiusmod.</li>
        <li>Ad dolor ea aliquip officia.</li>
      </ol>
    </li>
    <li>Aliqua anim esse eu ex.</li>
    <li>Est sit enim est.</li>
    <li>Labore deserunt elit dolor commodo mollit.</li>
  </ol>
    </Preview>
    <h3>{`No offset`}</h3>
    <Preview mdxType="Preview">
  <ul className="list--no-offset">
    <li>
      <strong>List no offset</strong>
    </li>
    <li>Ad dolor</li>
    <li>Aliqua anim</li>
    <li>Est sit</li>
  </ul>
    </Preview>
    <h3>{`Expanded`}</h3>
    <Preview mdxType="Preview">
  <ul className="list--expanded">
    <li>
      <strong>List expanded</strong>
    </li>
    <li>Ad dolor</li>
    <li>Aliqua anim</li>
    <li>Est sit</li>
  </ul>
    </Preview>
    <h3>{`Unstyled`}</h3>
    <Preview mdxType="Preview">
  <ul className="list--unstyled">
    <li>
      <strong>List unstyled</strong>
    </li>
    <li>Ad dolor</li>
    <li>Aliqua anim</li>
    <li>Est sit</li>
  </ul>
    </Preview>
    <h3>{`Inline list`}</h3>
    <Preview mdxType="Preview">
  <ul className="list-inline">
    <li>
      <strong>List inline</strong>
    </li>
    <li>Ad dolor</li>
    <li>Aliqua anim</li>
    <li>Est sit</li>
    <li>Labore deserunt</li>
  </ul>
  <ul className="list-inline list-inline--expanded">
    <li>
      <strong>List inline expanded</strong>
    </li>
    <li>Ad dolor</li>
    <li>Aliqua anim</li>
    <li>Est sit</li>
    <li>Labore deserunt</li>
  </ul>
  <ul className="list-inline list-inline--line">
    <li>
      <strong>List inline line</strong>
    </li>
    <li>Ad dolor</li>
    <li>Aliqua anim</li>
    <li>Est sit</li>
    <li>Labore deserunt</li>
  </ul>
    </Preview>
    <h3>{`Description list`}</h3>
    <Preview mdxType="Preview">
  <dl>
    <dt>Description list</dt>
    <dd>Do dolor anim sit dolore ex.</dd>
    <dt>Veniam ut amet</dt>
    <dd>Non dolore in sed.</dd>
    <dt>Eiusmod aute</dt>
    <dd>Eu sed sint irure.</dd>
  </dl>
    </Preview>
    <h3>{`Description list - inline`}</h3>
    <Preview mdxType="Preview">
  <dl className="dl-inline">
    <dt>Description list inline</dt>
    <dd>Do dolor anim sit dolore ex.</dd>
    <dt>Veniam ut amet</dt>
    <dd>Non dolore in sed.</dd>
    <dt>Eiusmod aute</dt>
    <dd>Eu sed sint irure.</dd>
  </dl>
    </Preview>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;